import { Link } from "react-router-dom";

export default function StampItem({ stamp }) {
  return (
    <div className="flex items-center justify-center">
      <Link to={`/stamps/${stamp.catalogue_id}`}>
        <img
          className="w-full h-auto rounded block hover:opacity-70 transition-opacity cursor-pointer"
          src={stamp.image}
          alt={stamp.subject || "Stamp"}
          loading="lazy"
        />
      </Link>
    </div>
  );
}
